module.exports = __webpack_public_path__ + "img/btn_category_add_on.4de47cf3.svg";